function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Polygon_5",
  "data-name": "Polygon 5",
  d: "M9.6,1.9a1,1,0,0,1,1.806,0l1.363,2.865a1,1,0,0,0,1.126.545l3.042-.7a1,1,0,0,1,1.13,1.4L16.69,8.974a1,1,0,0,0,.27,1.191l2.5,2.064a1,1,0,0,1-.4,1.743l-3.085.74a1,1,0,0,0-.767.967l-.016,3.239a1,1,0,0,1-1.629.772l-2.425-1.963a1,1,0,0,0-1.258,0L7.446,19.69a1,1,0,0,1-1.629-.772L5.8,15.679a1,1,0,0,0-.767-.967l-3.085-.74a1,1,0,0,1-.4-1.743l2.5-2.064a1,1,0,0,0,.27-1.191L2.937,6.009a1,1,0,0,1,1.13-1.4l3.042.7a1,1,0,0,0,1.126-.545Z",
  fill: "#01F2B4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_feather-check",
  "data-name": "Icon feather-check",
  d: "M16.756,9,9.361,16.395,6,13.033",
  transform: "translate(1.183 -3.149)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
});

function SvgVerifiedBatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_150_2",
    "data-name": "Component 150 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedBatch);
export default __webpack_public_path__ + "static/media/verifiedBatch.16f1a68f419aec2ec2c92027dbebf505.svg";
export { ForwardRef as ReactComponent };